import IconModel from '../models/IconModel';
import IService from './IService';
import Axios from 'axios';

export default class ChartService {

    constructor() {
    }

    async GetChartDataByIdPanel(model: any) {
        var res = await Axios.post('/api/Charts/getchartdatabyidpanel', model);
        return res.data;
    }


    async GetChartCoordenate(model: any) {
        var res = await Axios.post('/api/Charts/getchartcoordenate', model);
        return res.data;
    }

    async GetExcelHistoryData(filter: any) {
     
        var res = await Axios.post('/api/Charts/getExcelHistoryData', filter, {
            responseType: 'blob'
        }).then(response => {
            let result = {
                success:true,
                data: response.data
            }
            return result;
        }).catch(err => {
            let result = {
                success: false,
                Message: err.message
            }
            return result;            
        });
        return res;

    }

    async GetChartHistoryData(filter: any) {
        var res = await Axios.post('/api/Charts/getcharthistorydata', filter);
        return res.data;
    }


    async export(filter: any) {
        var res = await Axios.post('/api/Charts/export', filter, {
            responseType: 'blob'
        });
        return res.data;
    }
}